import {connect} from 'react-redux';
import * as actionsManagement from '../../actions/management';
import { list } from '../../actions/faculty';

import {
    getComplexTopicsDisciplines,
    getCurriculumForComplexTopicsDisciplines,
    getDisciplinesForComplexTopicsDisciplines,
    clearDisciplinesForComplexTopicsDisciplines,
    clearComplexTopicsDisciplines,
} from '../../actions/complexTopicsDisciplines';
import ComplexTopicsDisciplines from '../../components/complexTopicsDisciplines/complexTopicsDisciplines';
import { itemsPerPage } from '../../utils/const';

// Тело перечня — {count, complex_thematic_planning}: массив и счётчик разбираются здесь,
// в компонент приходят отдельными пропсами
const mapStateToProps = ({complexTopicsDisciplines, faculty, management}) => ({
    years: management.academicYear,
    facultyList: faculty.list,
    curriculum: complexTopicsDisciplines.curriculum,
    disciplines: complexTopicsDisciplines.disciplines,

    pagesCount:  Math.ceil((complexTopicsDisciplines.data.disciplines.count || 0) / itemsPerPage),
    totalCount:  complexTopicsDisciplines.data.disciplines.count || 0,
    complex: complexTopicsDisciplines.data.disciplines.complex_thematic_planning,
    errorStatus: complexTopicsDisciplines.data.disciplinesErrorStatus,
    isLoading: complexTopicsDisciplines.isLoading,
});

const mapDispatchToProps = dispatch => ({
    getYears: ()=> dispatch(actionsManagement.getAcademicYear()),
    fetchFacultyList: () => dispatch(list()),
    getComplexTopicsDisciplines: (params) => dispatch (getComplexTopicsDisciplines(params)),
    fetchCurriculum: (facultyid) => dispatch(getCurriculumForComplexTopicsDisciplines(facultyid)),
    fetchDisciplines: (curriculumid) => dispatch(getDisciplinesForComplexTopicsDisciplines(curriculumid)),
    clearDisciplines: () => dispatch(clearDisciplinesForComplexTopicsDisciplines()),
    clearComplex: () => dispatch(clearComplexTopicsDisciplines()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ComplexTopicsDisciplines);
